
import React, { useState, useEffect } from 'react';

const ExperianScoreReportModals = ({ isOpen, onClose, ExperianReport,

  Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
}) => {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
 // console.log("data exp1",ExperianReport);
  }, [ExperianReport], [Equifaxv2Error]);


  if (!isOpen) return null; // Do not render anything if not open

  const printDiv = () => {
    setIsPrinting(true);

    // Create a temporary window for printing
    const printWindow = window.open('', '', 'height=600,width=800');

    const printContents = document.getElementById("invoicedata").innerHTML;
    const reportName = ExperianReport?.name || '';
    // Write the content to the new window
    printWindow.document.write(`<html><head><title>Experian Report ${reportName}</title>`);
    printWindow.document.write('<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">');
    printWindow.document.write('</head><body >');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');

    printWindow.document.close(); // Close the document for rendering
    printWindow.focus(); // Focus on the new window

    setTimeout(() => {
      printWindow.print(); // Trigger print
      setIsPrinting(false);
    }, 100);
  };


  const responses = ExperianReport && ExperianReport?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS;

  function convertDateForm(time) {
    let s = `${time}`;
    return s.slice(0, 4) + "/" + s.slice(4, 6) + "/" + s.slice(6, 8);
  }



  // Helper function to convert date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    if (convertDateForm) return convertDateForm(dateString);
    return dateString;
  };



const accountTypeMap = {
    "1" : "Auto - Loan (Personal)",
    "2" : "Housing Loan",
    "3" : "Property Loan",
    "4" : "Loan Against Shares/Securities",
    "5" : "Personal Loan",
    "6" : "Consumer Loan",
    "7" : "Gold Loan",
    "8" : "Education Loan",
    "9" : "Loan to Professional",
    "10" : "Credit Card",
    "11" : "Leasing",
    "12" : "Overdraft",
    "13" : "Two-Wheeler Loan",
    "14" : "Non-Funded Credit Facility",
    "15" : "Loan Against Bank Deposits",
    "16" : "Fleet Card",
    "17" : "Commercial Vehicle Loan",
    "18" : "Telco – Wireless",
    "19" : "Telco – Broadband",
    "20" : "Telco – Landline",
    "21" : "Seller Financing",
    "23" : "GECL Loan Secured",
    "24" : "GECL Loan Unsecured",
    "31" : "Secured Credit Card",
    "32" : "Used Car Loan",
    "33" : "Construction Equipment Loan",
    "34" : "Tractor Loan",
    "35" : "Corporate Credit Card",
    "36" : "Kisan Credit Card",
    "37" : "Loan on Credit Card",
    "38" : "Prime Minister Jaan Dhan Yojana – Overdraft",
    "39" : "Mudra Loans – Shishu/Kishor/Tarun",
    "40" : "Microfinance – Business Loan",
    "41" : "Microfinance – Personal Loan",
    "42" : "Microfinance – Housing Loan",
    "43" : "Microfinance – Others",
    "44" : "Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS",
    "45" : "P2P Personal Loan",
    "46" : "P2P Auto Loan",
    "47" : "P2P Education Loan",
    "50" : "Business Loan – Secured",
    "51" : "Business Loan – General",
    "52" : "Business Loan – Priority Sector – Small Business",
    "53" : "Business Loan – Priority Sector – Agriculture",
    "54" : "Business Loan – Priority Sector – Others",
    "55" : "Business Non-Funded Credit Facility – General",
    "56" : "Business Non-Funded Credit Facility-Priority Sector- Small Business",
    "57" : "Business Non-Funded Credit Facility-Priority Sector-Agriculture",
    "58" : "Business Non-Funded Credit Facility-Priority Sector-Others",
    "59" : "Business Loan Against Bank Deposits",
    "61" : "Business Loan – Unsecured",
    "69" : "Short Term Personal Loan",
    "70" : "Priority Sector- Gold Loan",
    "71" : "Temporary Overdraft",
    "0" : "Other"
};


  return (
    <div className="fixed inset-0 flex  flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]" id="invoicedata">
        <div className="a4-page">






<div className="grid grid-cols-12 items-center">
  {/* Logo - Always at start */}
  <div className="col-span-3 flex justify-start">
    <img
      src="https://www.experian.com/static/shared/logos/logo-experian.svg"
      className="w-24 p-1"
      alt="Experian Logo"
    />
  </div>

  {/* Title - Center */}
  <div className="col-span-6 flex justify-center text-center">
    <h4 className="text-xl font-bold">Experian Credit Report</h4>
  </div>

  {/* Credit Score - End */}
  <div className="col-span-3 flex justify-end text-sm">
    Credit Score: <strong className="text-xl ml-1">
      {ExperianReport?.credit_score || 'N/A'}
    </strong>
  </div>
</div>

{/* Report Details Section */}
<div className="flex justify-between items-start flex-wrap mt-1 px-2">
  {(() => {
    const formatKey = (key) => {
      if (!key) return '';
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    const formatDateValue = (value) => {
      if (!value) return 'N/A';
      const str = String(value);
      
      // Handle YYYYMMDD format
      if (str.length === 8 && !isNaN(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        return `${day}-${month}-${year}`;
      }
      
      return value;
    };

    const reportDetails = {
      'Client ID': ExperianReport?.client_id,
      'Report Order No': ExperianReport?.credit_report?.CreditProfileHeader?.ReportNumber,
      'Report Date': formatDateValue(ExperianReport?.credit_report?.CreditProfileHeader?.ReportDate),
      'Report Time': (() => {
        const time = ExperianReport?.credit_report?.CreditProfileHeader?.ReportTime;
        if (!time) return null;
        const str = String(time).padStart(6, '0');
        return `${str.substring(0, 2)}:${str.substring(2, 4)}:${str.substring(4, 6)}`;
      })(),
      'Version': ExperianReport?.credit_report?.CreditProfileHeader?.Version
    };

    const leftDetails = [];
    const rightDetails = [];

    Object.entries(reportDetails).forEach(([key, value], idx) => {
      if (!value || value === 'N/A') return;
      
      const item = (
        <p className='text-xs' key={idx}>
          <i className='font-semibold'>{key}:</i>
          <span className="ml-1">{value}</span>
        </p>
      );

      // Put first 2 on left, rest on right
      if (idx < 2) {
        leftDetails.push(item);
      } else {
        rightDetails.push(item);
      }
    });

    return (
      <>
        <div>{leftDetails}</div>
        <div className="text-right">{rightDetails}</div>
      </>
    );
  })()}
</div>

{/* Personal Details Section */}
<div className='flex justify-center mt-1'>
  <p className='font-bold text-black text-sm'>Personal Details</p>
</div>

<div className="border border-blue-500 p-2 rounded-md mt-2">
  {(() => {
    // Helper to format keys - removes underscores and capitalizes
    const formatKey = (key) => {
      if (!key) return '';
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    // Helper to format date values
    const formatDateValue = (value) => {
      if (!value) return 'N/A';
      const str = String(value);
      
      // Handle YYYYMMDD format (20011115)
      if (str.length === 8 && !isNaN(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        return `${day}-${month}-${year}`;
      }
      
      return value;
    };

    // Helper to get value from multiple sources
    const getValue = (experianPath, equifaxErrorPath, equifaxDataPath) => {
      const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc?.[part], obj);
      };

      return getNestedValue(ExperianReport, experianPath) ||
             getNestedValue(Equifaxv2Error?.error, equifaxErrorPath) ||
             getNestedValue(Equifaxv2Error?.data, equifaxDataPath) ||
             'N/A';
    };

    // Build personal details object
    const personalDetails = {
      'Consumer Name': ExperianReport?.name || Equifaxv2Error?.data?.name || Equifaxv2Error?.error?.name,
      'Date of Birth': (() => {
        const dob = ExperianReport?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS?.[0]?.CAIS_Holder_Details?.[0]?.Date_of_birth ||
                     ExperianReport?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details?.Date_Of_Birth_Applicant ||
                     Equifaxv2Error?.error?.dob;
        return formatDateValue(dob);
      })(),
      'Mobile': ExperianReport?.mobile || 
                ExperianReport?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details?.MobilePhoneNumber ||
                Equifaxv2Error?.error?.mobile || 
                Equifaxv2Error?.data?.mobile,
      'Email': ExperianReport?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details?.EMailId ||
               Equifaxv2Error?.error?.email,
      'PAN/Aadhar': ExperianReport?.pan || 
                    ExperianReport?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details?.IncomeTaxPan ||
                    Equifaxv2Error?.error?.id_number || 
                    Equifaxv2Error?.data?.id_number,
      'Gender': (() => {
        const genderCode = ExperianReport?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details?.Gender_Code;
        return genderCode === '1' ? 'Male' : genderCode === '2' ? 'Female' : genderCode === '3' ? 'Other' : 'N/A';
      })()
    };

    // Get Current_Applicant_Details for additional fields
    const applicantDetails = ExperianReport?.credit_report?.Current_Application?.Current_Application_Details?.Current_Applicant_Details || {};
    
    // Add all other fields from Current_Applicant_Details dynamically
    Object.entries(applicantDetails).forEach(([key, value]) => {
      // Skip already added fields
      const skipFields = ['Last_Name', 'First_Name', 'Middle_Name1', 'Middle_Name2', 'Middle_Name3', 
                         'Gender_Code', 'IncomeTaxPan', 'Date_Of_Birth_Applicant', 'MobilePhoneNumber', 'EMailId'];
      
      if (!skipFields.includes(key) && value && value !== '') {
        const formattedKey = formatKey(key);
        const formattedValue = key.includes('Date') ? formatDateValue(value) : value;
        personalDetails[formattedKey] = formattedValue;
      }
    });

    return (
      <div className="grid grid-cols-3 md:grid-cols-3 gap-1">
        {Object.entries(personalDetails).map(([key, value], idx) => {
          if (!value || value === 'N/A' || value === '') return null;
          
          return (
            <div key={idx}>
              <p className='text-xs'>
                <i className='font-semibold'>{key}:</i>
                <span className="ml-1">{value}</span>
              </p>
            </div>
          );
        })}
      </div>
    );
  })()}
</div>





          {displayMessageBlock && (() => {
            const message =
              Equifaxv2Error?.error?.credit_report_message?.message ||
              Equifaxv2Error?.message ||
              ExperianReport?.message ||
              reportMessage ||
              "";

            const code =
              Equifaxv2Error?.error?.credit_report_message?.message_code ||
              Equifaxv2Error?.message_code ||
              ExperianReport?.message_code ||
              reportCode ||
              "";

            const isSuccess = message?.toLowerCase().includes("success");

            // 🛑 Don't show anything if it's success
            if (isSuccess) return null;

            const formatText = (text) =>
              text?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

            return (
              <>{(message?.length > 0 || code?.length > 0) && (
                <div className="flex flex-col items-center justify-center my-5">
                  <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                    <p className="text-center text-black font-bold text-sm">
                      Error: <span className="font-normal">{formatText(message)}</span>
                    </p>
                    <p className="text-center text-black font-bold mt-1 text-sm">
                      Code: <span className="font-normal">{formatText(code)}</span>
                    </p>
                  </div>
                </div>
              )}
              </>
            );
          })()}

    




          <hr className="my-1" />

<div className="bg-blue-900 text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
  Experian Score
</div>
{(() => {
  const scoreData = ExperianReport?.credit_report?.SCORE;

  // Return null if no score data
  if (!scoreData || typeof scoreData !== 'object') return null;

  // Helper to check if field has data
  const hasValue = (val) => {
    if (val === null || val === undefined) return false;
    if (typeof val === 'string' && val.trim() === '') return false;
    if (Array.isArray(val)) return val.length > 0;
    if (typeof val === 'object') return Object.keys(val).length > 0;
    return true;
  };

  // Helper to format field names
  const formatLabel = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/_/g, ' ')
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Get main score field (typically BureauScore, Score, CreditScore, etc.)
  const scoreKeys = ['BureauScore', 'Score', 'CreditScore', 'CIBIL_Score', 'Experian_Score'];
  const mainScoreKey = Object.keys(scoreData).find(key => scoreKeys.includes(key)) || 
                        Object.keys(scoreData).find(key => key.toLowerCase().includes('score'));
  
  const scoreValue = mainScoreKey ? scoreData[mainScoreKey] : null;

  // Get all other fields (exclude arrays/objects and main score)
  const allKeys = Object.keys(scoreData);
  const detailFields = allKeys.filter(key => {
    if (key === mainScoreKey) return false; // Skip main score
    const value = scoreData[key];
    if (Array.isArray(value) || (typeof value === 'object' && value !== null)) return false;
    return hasValue(value);
  });

  // Don't render if no data
  if (!hasValue(scoreValue) && detailFields.length === 0) return null;

  // Color coding based on score value
  const getScoreColor = (score) => {
    const numScore = parseInt(score);
    if (isNaN(numScore)) return { bg: 'bg-green-800', text: 'text-white', border: 'border-gray-400' };
    if (numScore >= 750) return { bg: 'bg-green-800', text: 'text-white', border: 'border-green-600' };
    if (numScore >= 650) return { bg: 'bg-green-800', text: 'text-white', border: 'border-yellow-600' };
    if (numScore >= 550) return { bg: 'bg-green-800', text: 'text-white', border: 'border-orange-600' };
    return { bg: 'bg-red-100', text: 'text-red-900', border: 'border-red-600' };
  };

  const scoreColors = getScoreColor(scoreValue);

  return (
    <div className="border border-blue-900 rounded-br-xl rounded-bl-xl overflow-hidden mb-2">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead className="bg-blue-100">
            <tr>
              {hasValue(scoreValue) && (
                <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-blue-900">
                  {formatLabel(mainScoreKey || 'Score')}
                </th>
              )}
              {detailFields.map((key, idx) => (
                <th key={idx} className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900">
                  {formatLabel(key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            <tr>
              {hasValue(scoreValue) && (
                <td className="border border-gray-300 px-2 py-1.5">
                  <div className={`flex flex-col items-center justify-center ${scoreColors.bg} rounded-lg ${scoreColors.border} border-2 p-2 w-14 h-14 mx-auto`}>
                    <span className={`text-2xl font-bold ${scoreColors.text}`}>
                      {scoreValue}
                    </span>
                    <span className={`text-[10px] font-semibold ${scoreColors.text}`}>
                      Score
                    </span>
                  </div>
                </td>
              )}
              {detailFields.map((key, idx) => (
                <td key={idx} className="border border-gray-300 px-2 py-1 text-gray-700 font-medium">
                  {scoreData[key]}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
})()}








          {/* Accounts Section */}
          <div className=" bg-blue-900 md:text-white text-white p-1 mt-1 rounded-tr-xl rounded-tl-xl text-sm">Account Details</div>
          {/* 1st Retail */}
 
<table className="min-w-full table-auto text-left mt-2 border-collapse">
  <tbody>
    {responses && Array.isArray(responses) && responses.length > 0 && (
      <tr>
        <td colSpan={6} className="px-1 py-0">
          <div className="flex flex-col gap-3 mt-1">
            {responses.map((LinkedAC, idx) => {
              const typeCode = LinkedAC?.Account_Type || "N/A";
              const accountTypeName = accountTypeMap[typeCode] || "Not Specified";

              // FIXED: Better hasValue check (handles 0 and false correctly)
              const hasValue = (val) => {
                if (val === null || val === undefined) return false;
                if (typeof val === 'string' && val.trim() === '') return false;
                if (Array.isArray(val) && val.length === 0) return false;
                if (typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length === 0) return false;
                return true;
              };

              // Helper to check if value is a non-empty array
              const isArray = (val) => Array.isArray(val) && val.length > 0;

              // Helper to format field names
              const formatLabel = (key) => {
                return key
                  .replace(/_/g, ' ')
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ');
              };

              // Helper to format value with proper styling
              const formatValue = (key, value) => {
                if (key.includes('Amount') || key.includes('Balance') || key.includes('Credit') || key.includes('Loan')) {
                  const amount = parseFloat(value) || 0;
                  const colorClass = key.includes('Past_Due') || key.includes('Written_Off') 
                    ? (amount > 0 ? 'text-red-600' : 'text-green-600')
                    : 'text-blue-600';
                  return <span className={`${colorClass} font-semibold`}>₹{amount}</span>;
                }
                
                if (key.includes('Date') && typeof value === 'string' && value.length === 8) {
                  return <span className="text-gray-700 font-semibold">{formatDate(value)}</span>;
                }

                if (key.includes('Interest') || key.includes('Rate')) {
                  return <span className="text-purple-600 font-semibold">{value}%</span>;
                }

                if (key === 'Account_Type') {
                  return <span className="text-yellow-600 font-semibold">{accountTypeName}</span>;
                }

                return <span className="text-gray-700 font-semibold">{value}</span>;
              };

              // Fields to skip (already shown elsewhere or redundant)
              const fieldsToSkip = ['Payment_History_Profile'];

              // DYNAMIC: Automatically separate main fields and nested arrays
              const allKeys = Object.keys(LinkedAC || {});
              const mainFields = [];
              const nestedArrays = [];

              allKeys.forEach(key => {
                // Skip specific fields
                if (fieldsToSkip.includes(key)) return;

                const value = LinkedAC[key];
                if (isArray(value)) {
                  nestedArrays.push({ key, data: value });
                } else if (hasValue(value)) {
                  mainFields.push(key);
                }
              });

              // Function to render ANY nested array as table
              const renderNestedTable = (data, title) => {
                if (!Array.isArray(data) || data.length === 0) return null;

                // Get all keys from all objects in array
                const allNestedKeys = new Set();
                data.forEach(item => {
                  if (item && typeof item === 'object') {
                    Object.keys(item).forEach(key => allNestedKeys.add(key));
                  }
                });

                // Filter to show only fields with data
                const displayKeys = Array.from(allNestedKeys).filter(key => {
                  return data.some(item => hasValue(item?.[key]));
                });

                if (displayKeys.length === 0) return null;

                return (
                  <div className="mt-3 border-t pt-2">
                    <p className="font-bold mb-2 text-sm text-gray-800">{title}</p>
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse text-xs">
                        <thead className="bg-blue-100">
                          <tr>
                            <th className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900 w-12">S.No.</th>
                            {displayKeys.map((key, kidx) => (
                              <th key={kidx} className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900">
                                {formatLabel(key)}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="bg-white">
                          {data.map((item, itemIdx) => (
                            <tr key={itemIdx} className={itemIdx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                              <td className="border border-gray-300 px-2 py-1 font-medium text-gray-700">{itemIdx + 1}</td>
                              {displayKeys.map((key, keyIdx) => (
                                <td key={keyIdx} className="border border-gray-300 px-2 py-1 text-gray-600">
                                  {item?.[key] || '-'}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              };

              return (
                <div key={idx} className="w-full border rounded-md p-1 bg-white shadow-sm">
                  {/* Heading */}
                  <h3 className="bg-blue-900 text-white p-1 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
                    Loan Type: {accountTypeName}
                  </h3>

                  {/* Main Account Details Grid */}
                  {mainFields.length > 0 && (
                    <div className="grid grid-cols-3 gap-2 mb-2 p-2 text-xs">
                      {mainFields.map((key, fieldIdx) => (
                        <div key={fieldIdx}>
                          <span className="font-semibold text-gray-600">{formatLabel(key)}:</span>{" "}
                          {formatValue(key, LinkedAC[key])}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* DYNAMIC: Render ALL nested arrays automatically */}
                  {nestedArrays.map((arr, arrIdx) => (
                    <React.Fragment key={arrIdx}>
                      {arr.key === 'CAIS_Account_History' ? (
                        <PaymentHistoryLists history={arr.data} />
                      ) : (
                        renderNestedTable(arr.data, formatLabel(arr.key))
                      )}
                    </React.Fragment>
                  ))}
                </div>
              );
            })}
          </div>
        </td>
      </tr>
    )}
  </tbody>
</table>
 
   




          <div className="bg-blue-900 hidden md:text-white text-white p-1 mt-2 rounded-tr-xl rounded-tl-xl text-sm">Account Summary</div>
          <div className="hidden gap-1 mt-1">

            {/* Primary Accounts Summary Card */}
            <div className="bg-gray-300 p-1 rounded-lg shadow-lg">
              <h2 className="font-semibold text-sm mb-1 bg-blue-700 rounded-sm text-white text-center">Primary Accounts Summary</h2>
              <div>
                <p className='border-b text-xs'><span className="font-semibold">Number of Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Active Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Overdue Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><spna className="font-semibold">Secured Accounts: </spna>{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SECURED-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><spna className="font-semibold">Unsecured Accounts: </spna>{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Current Balance:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-CURRENT-BALANCE"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Sanctioned Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SANCTIONED-AMOUNT"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Disbursed Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-DISBURSED-AMOUNT"]}</p>
              </div>
            </div>

            {/* Secondary Accounts Summary Card */}
            <div className="bg-gray-300  p-1 rounded-lg shadow-lg">
              <h2 className="font-semibold text-sm mb-1 bg-blue-700 rounded-sm text-white text-center">Secondary Accounts Summary</h2>
              <div>
                <p className='border-b text-xs'><span className="font-semibold">Number of Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Active Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Overdue Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Current Balance:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-CURRENT-BALANCE"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Sanctioned Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-SANCTIONED-AMOUNT"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Disbursed Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-DISBURSED-AMOUNT"]}</p>
              </div>
            </div>

            {/* Derived Attributes Card */}
            <div className="bg-gray-300  p-1 rounded-lg shadow-lg">
              <h2 className="font-semibold text-sm mb-1 bg-blue-700 rounded-sm text-white text-center">Derived Attributes</h2>
              <div>
                <p className='border-b text-xs'><span className="font-semibold">Inquiries in Last 6 Months:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["INQUIRIES-IN-LAST-SIX-MONTHS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">Length of Credit History:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-YEAR"]} Year, {ExperianReport?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-MONTH"]} Month</p>
                <p className='border-b text-xs'><span className="font-semibold">Average Account Age:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-YEAR"]} Year, {ExperianReport?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-MONTH"]} Month</p>
                <p className='border-b text-xs'><span className="font-semibold">New Accounts in Last 6 Months:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"]}</p>
                <p className='border-b text-xs'><span className="font-semibold">New Delinquent Accounts in Last 6 Months:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"]}</p>
              </div>
            </div>
          </div>

          {/* Recent Activity Section */}
          <div className="  bg-blue-900 hidden md:text-white text-white p-1 mt-2 rounded-tr-xl rounded-tl-xl text-sm">Recent Activity (Last 90 Days)</div>
          <table className="min-w-full hidden table-auto border border-black text-left">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-black px-4 py-2">Total Inquiries</th>
                <th className="border border-black px-4 py-2">InquiryPast30Days</th>
                <th className="border border-black px-4 py-2">Inquiry Past 24Months</th>
                <th className="border border-black px-4 py-2">Recent Inquiry date</th>
              </tr>
            </thead>
            <tbody className="recentActivity">
            </tbody>
          </table>
        </div>



<div class="overflow-y-auto">
  <table class="min-w-full border border-gray-200 text-xs">
    <thead class="bg-gray-100 sticky top-0">
      <tr>
        <th class="border border-gray-200 px-2 py-1 text-left w-14">Code</th>
        <th class="border border-gray-200 px-2 py-1 text-left">Account Type</th>
        <th class="border border-gray-200 px-2 py-1 text-left w-14">Code</th>
        <th class="border border-gray-200 px-2 py-1 text-left">Account Type</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="border border-gray-100 px-1 py-0">01</td>
        <td class="border border-gray-100 px-1 py-0">Auto - Loan (Personal)</td>
        <td class="border border-gray-100 px-1 py-0">02</td>
        <td class="border border-gray-100 px-1 py-0">Housing Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">03</td>
        <td class="border border-gray-100 px-1 py-0">Property Loan</td>
        <td class="border border-gray-100 px-1 py-0">04</td>
        <td class="border border-gray-100 px-1 py-0">Loan Against Shares/Securities</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">05</td>
        <td class="border border-gray-100 px-1 py-0">Personal Loan</td>
        <td class="border border-gray-100 px-1 py-0">06</td>
        <td class="border border-gray-100 px-1 py-0">Consumer Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">07</td>
        <td class="border border-gray-100 px-1 py-0">Gold Loan</td>
        <td class="border border-gray-100 px-1 py-0">08</td>
        <td class="border border-gray-100 px-1 py-0">Education Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">09</td>
        <td class="border border-gray-100 px-1 py-0">Loan to Professional</td>
        <td class="border border-gray-100 px-1 py-0">10</td>
        <td class="border border-gray-100 px-1 py-0">Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">11</td>
        <td class="border border-gray-100 px-1 py-0">Leasing</td>
        <td class="border border-gray-100 px-1 py-0">12</td>
        <td class="border border-gray-100 px-1 py-0">Overdraft</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">13</td>
        <td class="border border-gray-100 px-1 py-0">Two-Wheeler Loan</td>
        <td class="border border-gray-100 px-1 py-0">14</td>
        <td class="border border-gray-100 px-1 py-0">Non-Funded Credit Facility</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">15</td>
        <td class="border border-gray-100 px-1 py-0">Loan Against Bank Deposits</td>
        <td class="border border-gray-100 px-1 py-0">16</td>
        <td class="border border-gray-100 px-1 py-0">Fleet Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">17</td>
        <td class="border border-gray-100 px-1 py-0">Commercial Vehicle Loan</td>
        <td class="border border-gray-100 px-1 py-0">18</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Wireless</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">19</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Broadband</td>
        <td class="border border-gray-100 px-1 py-0">20</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Landline</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">21</td>
        <td class="border border-gray-100 px-1 py-0">Seller Financing</td>
        <td class="border border-gray-100 px-1 py-0">23</td>
        <td class="border border-gray-100 px-1 py-0">GECL Loan Secured</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">24</td>
        <td class="border border-gray-100 px-1 py-0">GECL Loan Unsecured</td>
        <td class="border border-gray-100 px-1 py-0">31</td>
        <td class="border border-gray-100 px-1 py-0">Secured Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">32</td>
        <td class="border border-gray-100 px-1 py-0">Used Car Loan</td>
        <td class="border border-gray-100 px-1 py-0">33</td>
        <td class="border border-gray-100 px-1 py-0">Construction Equipment Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">34</td>
        <td class="border border-gray-100 px-1 py-0">Tractor Loan</td>
        <td class="border border-gray-100 px-1 py-0">35</td>
        <td class="border border-gray-100 px-1 py-0">Corporate Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">36</td>
        <td class="border border-gray-100 px-1 py-0">Kisan Credit Card</td>
        <td class="border border-gray-100 px-1 py-0">37</td>
        <td class="border border-gray-100 px-1 py-0">Loan on Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">38</td>
        <td class="border border-gray-100 px-1 py-0">Prime Minister Jaan Dhan Yojana – Overdraft</td>
        <td class="border border-gray-100 px-1 py-0">39</td>
        <td class="border border-gray-100 px-1 py-0">Mudra Loans – Shishu/Kishor/Tarun</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">40</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Business Loan</td>
        <td class="border border-gray-100 px-1 py-0">41</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">42</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Housing Loan</td>
        <td class="border border-gray-100 px-1 py-0">43</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Others</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">44</td>
        <td class="border border-gray-100 px-1 py-0">
          Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS
        </td>
        <td class="border border-gray-100 px-1 py-0">45</td>
        <td class="border border-gray-100 px-1 py-0">P2P Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">46</td>
        <td class="border border-gray-100 px-1 py-0">P2P Auto Loan</td>
        <td class="border border-gray-100 px-1 py-0">47</td>
        <td class="border border-gray-100 px-1 py-0">P2P Education Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">50</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – Secured</td>
        <td class="border border-gray-100 px-1 py-0">51</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – General</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">52</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Small Business
        </td>
        <td class="border border-gray-100 px-1 py-0">53</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Agriculture
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">54</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Others
        </td>
        <td class="border border-gray-100 px-1 py-0">55</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – General
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">56</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Small Business
        </td>
        <td class="border border-gray-100 px-1 py-0">57</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Agriculture
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">58</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Others
        </td>
        <td class="border border-gray-100 px-1 py-0">59</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan Against Bank Deposits
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">61</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – Unsecured</td>
        <td class="border border-gray-100 px-1 py-0">69</td>
        <td class="border border-gray-100 px-1 py-0">Short Term Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">70</td>
        <td class="border border-gray-100 px-1 py-0">Priority Sector- Gold Loan</td>
        <td class="border border-gray-100 px-1 py-0">71</td>
        <td class="border border-gray-100 px-1 py-0">Temporary Overdraft</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">00</td>
        <td class="border border-gray-100 px-1 py-0">Other</td>
        <td class="border border-gray-100 px-1 py-0"></td>
        <td class="border border-gray-100 px-1 py-0"></td>
      </tr>
    </tbody>
  </table>
</div>



{/* Summary Section */}
<div className="bg-blue-900 text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
  Summary
</div>

{/* Dynamic CAIS Summary Grid */}
<div className="min-w-full border border-gray-300 p-2 text-xs grid grid-cols-2 gap-2">
  {(() => {
    // Helper function to format keys - removes underscores and capitalizes
    const formatKey = (key) => {
      if (!key) return '';
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    // Helper function to format values
    const formatValue = (value) => {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'boolean') return value ? 'Yes' : 'No';
      if (typeof value === 'number' || !isNaN(value)) {
        return parseFloat(value).toLocaleString('en-IN');
      }
      return String(value);
    };

    // Helper to assign color based on key
    const getColorByKey = (key) => {
      if (!key) return "text-gray-700";
      const lower = key.toLowerCase();
      if (lower.includes('active')) return "text-blue-600 font-semibold";
      if (lower.includes('total') || lower.includes('balance') || lower.includes('outstanding')) 
        return "text-green-600 font-bold";
      if (lower.includes('default') || lower.includes('overdue') || lower.includes('suit')) 
        return "text-red-600 font-semibold";
      if (lower.includes('closed') || lower.includes('zero')) 
        return "text-yellow-600 font-semibold";
      if (lower.includes('secured') || lower.includes('unsecured') || lower.includes('percentage')) 
        return "text-purple-600 font-semibold";
      return "text-gray-700";
    };

    // Get CAIS Summary data
    const caisSummary = ExperianReport?.credit_report?.CAIS_Account?.CAIS_Summary;
    
    if (!caisSummary) {
      return (
        <div className="col-span-2 text-gray-500 text-center py-4">
          No summary data available
        </div>
      );
    }

    const allEntries = [];

    // Dynamically iterate through all properties in CAIS_Summary
    Object.entries(caisSummary).forEach(([sectionKey, sectionValue]) => {
      if (sectionValue && typeof sectionValue === 'object' && !Array.isArray(sectionValue)) {
        // Add all key-value pairs from this section
        Object.entries(sectionValue).forEach(([key, value]) => {
          allEntries.push([key, value]);
        });
      }
    });

    if (allEntries.length === 0) {
      return (
        <div className="col-span-2 text-gray-500 text-center py-4">
          No summary data available
        </div>
      );
    }

    return allEntries.map(([key, value], i) => (
      <div key={`summary-${i}`} className="flex justify-between border-b border-gray-200 pb-1">
        <span className="font-semibold text-gray-600">{formatKey(key)}</span>
        <span className={getColorByKey(key)}>{formatValue(value)}</span>
      </div>
    ));
  })()}
</div>

{/* Dynamic Table: Credit Account Summary */}
{(() => {
  const creditAccount = ExperianReport?.credit_report?.CAIS_Account?.CAIS_Summary?.Credit_Account;
  
  if (!creditAccount || typeof creditAccount !== 'object') return null;

  const entries = Object.entries(creditAccount);
  if (entries.length === 0) return null;

  // Split entries into groups of 3 for table columns
  const tableGroups = [];
  for (let i = 0; i < entries.length; i += 3) {
    tableGroups.push(entries.slice(i, i + 3));
  }

  return tableGroups.map((group, groupIndex) => (
    <table key={`credit-table-${groupIndex}`} className="min-w-full table-auto border border-black text-left mt-2 text-sm">
      <thead className="bg-gray-200">
        <tr>
          {group.map(([key], idx) => (
            <th key={`header-${idx}`} className="border border-black px-2 py-1">
              {key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ').replace('Credit Account', '').trim()}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr className="bg-gray-50 hover:bg-gray-100">
          {group.map(([key, value], idx) => {
            const lower = key.toLowerCase();
            let colorClass = "text-gray-700";
            
            if (lower.includes('active')) colorClass = "text-blue-600 font-semibold";
            else if (lower.includes('default') || lower.includes('suit')) colorClass = "text-red-600 font-bold";
            else if (lower.includes('closed')) colorClass = "text-yellow-600 font-semibold";
            else if (lower.includes('total')) colorClass = "text-green-600 font-bold";

            return (
              <td key={`cell-${idx}`} className={`border border-black px-2 py-1 ${colorClass}`}>
                {parseFloat(value || 0).toLocaleString('en-IN')}
              </td>
            );
          })}
        </tr>
      </tbody>
    </table>
  ));
})()}

{/* Dynamic Table: Outstanding Balance Summary */}
{(() => {
  const outstandingBalance = ExperianReport?.credit_report?.CAIS_Account?.CAIS_Summary?.Total_Outstanding_Balance;
  
  if (!outstandingBalance || typeof outstandingBalance !== 'object') return null;

  const entries = Object.entries(outstandingBalance);
  if (entries.length === 0) return null;

  // Split entries into groups of 3 for table columns
  const tableGroups = [];
  for (let i = 0; i < entries.length; i += 3) {
    tableGroups.push(entries.slice(i, i + 3));
  }

  return tableGroups.map((group, groupIndex) => (
    <table key={`balance-table-${groupIndex}`} className="min-w-full table-auto border border-black text-left mt-2 text-sm">
      <thead className="bg-gray-200">
        <tr>
          {group.map(([key], idx) => (
            <th key={`header-${idx}`} className="border border-black px-2 py-1">
              {key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ').replace('Outstanding Balance', '').trim()}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr className="bg-gray-50 hover:bg-gray-100">
          {group.map(([key, value], idx) => {
            const lower = key.toLowerCase();
            let colorClass = "text-gray-700";
            
            if (lower.includes('secured') && !lower.includes('un')) colorClass = "text-purple-600 font-semibold";
            else if (lower.includes('unsecured')) colorClass = "text-orange-600 font-semibold";
            else if (lower.includes('percentage')) colorClass = "text-blue-600 font-semibold";
            else if (lower.includes('all') || lower.includes('total')) colorClass = "text-green-600 font-bold";

            return (
              <td key={`cell-${idx}`} className={`border border-black px-2 py-1 ${colorClass}`}>
                {lower.includes('percentage') 
                  ? `${parseFloat(value || 0).toFixed(1)}%`
                  : parseFloat(value || 0).toLocaleString('en-IN')
                }
              </td>
            );
          })}
        </tr>
      </tbody>
    </table>
  ));
})()}






          <div className='mt-4'>
  <h3 className="text-green-800 text-center font-bold">END of Report  {" "}
                  :{" "}
                  {ExperianReport && ExperianReport?.name
                  || Equifaxv2Error?.data?.name ||
                  Equifaxv2Error?.error?.name || "N/A"
                }
    
    </h3>
</div>

      </div>
      <div className="flex justify-center mt-4 gap-3">
        <button
          className="bg-green-500 text-white p-1 rounded hover:bg-green-700 border-black border"
          onClick={printDiv}
          disabled={isPrinting}
        >
          Print
        </button>
        <button
          className="bg-red-500 text-white p-1 rounded hover:bg-red-700 border-black border"
          onClick={onClose} // This should close the modal
        >
          Close
        </button>
      </div>
    </div >
  );
};


const PaymentHistoryLists = ({ history }) => {
  if (!history || !Array.isArray(history) || history.length === 0) {
    return null;
  }

  // Known classification map (with proper colors)
  const classificationMap = {
    'S': { color: 'bg-green-500', label: 'Standard', textColor: 'text-green-700' },
    'D': { color: 'bg-red-500', label: 'Default', textColor: 'text-red-700' },
    'P': { color: 'bg-yellow-400', label: 'Past Due', textColor: 'text-yellow-700' },
    'X': { color: 'bg-blue-500', label: 'Special', textColor: 'text-blue-700' },
    'N': { color: 'bg-gray-400', label: 'Not Reported', textColor: 'text-gray-700' },
    // Additional common codes
    'SUB': { color: 'bg-orange-400', label: 'Sub-Standard', textColor: 'text-orange-700' },
    'DBT': { color: 'bg-purple-500', label: 'Doubtful', textColor: 'text-purple-700' },
    'LSS': { color: 'bg-pink-500', label: 'Loss', textColor: 'text-pink-700' },
    'STD': { color: 'bg-green-500', label: 'Standard', textColor: 'text-green-700' }
  };

  // Helper to get config for any classification (including unknown)
  const getClassificationConfig = (code) => {
    if (classificationMap[code]) {
      return classificationMap[code];
    }
    // Default for unknown classifications
    return {
      color: 'bg-gray-500',
      label: code || 'Unknown',
      textColor: 'text-gray-700'
    };
  };

  // Collect all unique classifications from actual data
  const uniqueClassifications = new Set();
  history.forEach(item => {
    const code = item.Asset_Classification || 'N';
    uniqueClassifications.add(code);
  });

  return (
    <div className="w-full mb-2 p-2 bg-gray-50 rounded-md">
      <p className="font-bold mb-2 text-sm text-gray-800">Payment History</p>
      
      {/* History Timeline */}
      <div className="flex flex-wrap gap-2">
        {history.map((item, idx) => {
          const classification = item.Asset_Classification || 'N';
          const monthYear = `${item.Month}/${item.Year}`;
          const config = getClassificationConfig(classification);

          return (
            <div
              key={idx}
              className="flex flex-col items-center p-1 border border-gray-300 rounded-md w-16 text-center bg-white hover:shadow-md transition-shadow"
              title={`${config.label} - ${monthYear}${item.Days_Past_Due ? ` (${item.Days_Past_Due} days)` : ''}`}
            >
              <div className={`w-5 h-5 rounded-full mb-1 ${config.color} shadow-sm`}></div>
              <span className="text-[11px] font-medium text-gray-700">{monthYear}</span>
              <span className={`text-[9px] ${config.textColor} font-semibold`}>{classification}</span>
              {item.Days_Past_Due && (
                <span className="text-[8px] text-red-600">{item.Days_Past_Due}d</span>
              )}
            </div>
          );
        })}
      </div>

      {/* Dynamic Legend - Only show classifications that appear in data */}
      <div className="flex gap-2 mt-3 text-xs flex-wrap border-t pt-2">
        {Array.from(uniqueClassifications).sort().map((code) => {
          const config = getClassificationConfig(code);
          return (
            <div key={code} className="flex items-center gap-1">
              <div className={`w-3 h-3 rounded-full ${config.color}`}></div>
              <span className="text-gray-700">{config.label} ({code})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};


export default ExperianScoreReportModals;
